module.exports = __webpack_public_path__ + "static/media/rooms-menu-icon.65c8e7d9.svg";